import { DatetimeChangeEventDetail, IonDatetime } from '@ionic/react'
import dayjs from 'dayjs'
import React, { useContext } from 'react'
import { useTranslation } from 'react-i18next'
import Button from '../../../../components/actions/Button'
import useUser from '../../../../contexts/hooks/useUser'
import { ModalContext } from '../../../../contexts/ModalContext'
import { trpc } from '../../../../modules/trpc'
import ModalWrapper from '../../../../wrappers/modalWrapper/ModalWrapper'

interface DateTimeChangeEvent {
	detail: DatetimeChangeEventDetail
}

const SmartChargeControllerModal: React.FC = () => {
	const utils = trpc.useContext()

	const { closeModal, timeValue, setTimeValue, selectedVehicles } = useContext(ModalContext)

	const [tempTimeValue, setTempTimeValue] = React.useState(timeValue)

	const mutation = trpc.eNode.charging.setSmartChargingPolicy.useMutation({
		onSuccess() {
			utils.eNode.vehicles.get.invalidate()
			utils.eNode.vehicles.getSingle.invalidate()
			utils.eNode.charging.getSmartChargingStatus.invalidate()
		},
	})

	const { user } = useUser()

	const { t } = useTranslation('pages_electricCar')

	const saveHandler = () => {
		const time = dayjs(tempTimeValue).format('HH:mm')
		setTimeValue(tempTimeValue)

		selectedVehicles.forEach(vehicle =>
			mutation.mutate({
				hashedPid: user!.hashedPid,
				vehicleId: vehicle.id,
				options: {
					deadline: time,
					isEnabled: true,
					minimumChargeLimit: 20,
				},
			})
		)

		closeModal()
	}

	const handleChange = (e: DateTimeChangeEvent) => {
		setTempTimeValue(e.detail.value as string)
	}

	return (
		<ModalWrapper>
			<IonDatetime
				value={tempTimeValue}
				onIonChange={handleChange}
				locale='fi-FI'
				hourCycle='h23'
				presentation='time'
				className='
					border border-[f5f5f5] dark:border-[#0a4448]
					max-w-full
					rounded-3xl
					![--background:rgb(245,245,245)]
					![--background-rgb:245,245,245]
					![--wheel-fade-background-rgb:245,245,245]
					[&::part(wheel-item)]:!text-text-dark
					[&::part(wheel-item_active)]:!text-brand-primary-100-light
					dark:![--background:rgb(3,31,34)]
					dark:![--wheel-fade-background-rgb:3,31,34]
					dark:[&::part(wheel-item)]:!text-white
					dark:[&::part(wheel-item_active)]:!text-brand-primary-100-dark
				'
			/>
			<div className='flex flex-col gap-2'>
				<Button onClick={saveHandler} className='m-0'>
					{t('tallenna', { ns: 'common' })}
				</Button>
				<Button onClick={closeModal} className='hollow m-0'>
					{t('peruuta', { ns: 'common' })}
				</Button>
			</div>
		</ModalWrapper>
	)
}

export default SmartChargeControllerModal
